import { BASE_API_URL } from "./constants.js"
import { systemTranslations } from "./systemTranslations.js"

export const localization = async (language) => {
    const response = await fetch(BASE_API_URL + 'texts/' + language, {
        "headers": {
            "Accept-Encoding": "gzip, compress, br",
        }
    })
    const apiTexts = await response.json()
    const formattedTexts = systemTranslations[language]

    apiTexts.forEach((apiText) => {
        formattedTexts[apiText.textId] = apiText.text
    })

    return formattedTexts
}

export const formatDate = (inputDate, language) => {
    // language can be de-DE, it-IT, en-US
    // export in formats dd.mm.yyyy, dd/mm/yyyy, or dd/mm/yyyy

    // Parse the input date
    let date
    if (inputDate instanceof Date) {
        date = inputDate
    } else {
        // Try to parse the input date if it's a string
        date = new Date(inputDate)
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
        return "Invalid Date"
    }

    // Format date according to language preference
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()

    switch (language) {
        case "de-DE":
            // German format: dd.mm.yyyy
            return `${day}.${month}.${year}`
        case "it-IT":
            // Italian format: dd/mm/yyyy
            return `${day}/${month}/${year}`
        case "en-US":
            // US format: mm/dd/yyyy
            return `${month}/${day}/${year}`
        default:
            // Default to ISO format
            return `${year}-${month}-${day}`
    }
}
